import { useState } from 'react';
import { View, ActivityIndicator } from 'react-native';

import { Button, COLORS, Text, TextField } from '../Basics';
import { InputRow } from '../Forms';
import { Screen } from '../../screens/Screen';
import { useStore } from '../../store/Context';

export const LorentzLoginScreen = ({ visible, onSuccess, embedMode = false, embedDefaults = {} }) => {
  const { settingsUri, lorentz = {}, login } = useStore();

  const [agent, setAgent] = useState(
    embedDefaults.username || lorentz.username || ''
  );
  const [group, setGroup] = useState(
    embedDefaults.groupName || lorentz.groupName || ''
  );
  const [password, setPassword] = useState('');
  const [configUrl, setConfigUrl] = useState(
    embedDefaults.configUrl || settingsUri || '/cfgLorentz008.json'
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setError('');
    setLoading(true);

    try {
      if (!agent.trim()) throw new Error('Informe o login do agente');
      if (!group.trim()) throw new Error('Informe o grupo');
      if (!password) throw new Error('Informe a senha');
      if (!configUrl.trim()) throw new Error('Informe a URL de configuração');

      await login({
        settingsUri: configUrl.trim(),
        nickname: agent.trim(),
        password,
        lorentzCredentials: {
          username: agent.trim(),
          groupName: group.trim(),
          password
        }
      });

      onSuccess?.();
    } catch (err) {
      setError(err?.message || 'Falha no login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen visible={visible} closeable={false} color={COLORS.app}>
      <View style={{ flex: 1, padding: 24, justifyContent: 'center' }}>
        <Text style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 4 }}>
          Cliente Lorentz Web
        </Text>
        <Text style={{ color: COLORS.textSecondary, marginBottom: 20 }}>
          {embedMode
            ? 'Autentique-se com seu login de operador CTI'
            : 'Autentique-se para iniciar o CTI'}
        </Text>

        {!embedMode ? (
          <InputRow
            label="URL de configuração"
            placeholder="http://servidor:8081/cfgLorentz008.json"
            value={configUrl}
            onChange={setConfigUrl}
          />
        ) : null}
        <InputRow
          label="Agente"
          placeholder="login do operador"
          value={agent}
          onChange={setAgent}
        />
        <InputRow
          label="Grupo"
          placeholder="nome do grupo CTI"
          value={group}
          onChange={setGroup}
        />
        <InputRow
          label="Senha"
          secureTextEntry
          placeholder="senha do agente"
          value={password}
          onChange={setPassword}
        />

        {error ? (
          <Text style={{ color: COLORS.danger, marginTop: 8 }}>{error}</Text>
        ) : null}

        <View style={{ marginTop: 20 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogin}
            testID="lorentzLoginSubmit"
          >
            {loading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <Text style={{ color: '#fff', fontWeight: 'bold' }}>Entrar</Text>
            )}
          </Button>
        </View>
      </View>
    </Screen>
  );
};

export default LorentzLoginScreen;
